(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.password-rules', ['pp.widgets-templates']);

ngModule.component('ppPasswordRules', {
    templateUrl: 'widgets/_angular/password-rules/password-rules.tpl.html',
    bindings: {
        passwordField: '<',
        feedbackEnabled: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);